export const validateNoBlankSpaces = (value) => {
  try {
    return (
      value.trim().length > 0 ||
      "This field cannot be blank or contain only spaces."
    );
  } catch {
    return true;
  }
};
